import React from 'react';
import Hero from '../components/Hero';
import Vision from '../components/Vision';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Testimonials from '../components/Testimonials';
import Process from '../components/Process';
import WhyChooseUs from '../components/WhyChooseUs';
import Contact from '../components/Contact';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Vision />
      <Services />
      <Portfolio />
            <WhyChooseUs />

      <Process />
            <Testimonials />

      <Contact />
    </>
  );
};

export default HomePage;
